import {
  BaseHttpClientFactory,
  HttpClientTypes,
  ICobrandingAssetResponse,
} from '@amzn/work-spaces-web-client-core-lib';

export class HttpClientFactory extends BaseHttpClientFactory {
  static getCobrandingHttpClient() {
    return this._getHttpClient<ICobrandingAssetResponse>(
      HttpClientTypes.cobranding
    );
  }
}
